import { render, staticRenderFns } from "./rural.vue?vue&type=template&id=7a260eb6&scoped=true&"
import script from "./rural.vue?vue&type=script&lang=js&"
export * from "./rural.vue?vue&type=script&lang=js&"
import style0 from "./rural.vue?vue&type=style&index=0&id=7a260eb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a260eb6",
  null
  
)

export default component.exports